import React from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported
import { motion } from "framer-motion";
import ProductShowcase1 from "./P1";
import ProductShowcase2 from "./P2";

const Products = () => {
  return (
    <motion.div
      id="products"
      className="container-fluid bg-black text-white min-vh-100 d-flex"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.2 }} // Triggers when 20% is in view
    >
      <div className="container my-5">
        <motion.h1
          className="about-heading fw-bold mb-4"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          Our Products
        </motion.h1>

        {/* Animated Product Showcase */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true }}
        >
          <ProductShowcase1 />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
          viewport={{ once: true }}
        >
          <ProductShowcase2 />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Products;
